<template>
    <div class="cl-button" v-on="$listeners" :class="[type, size]">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "clButton",
        props: {
            type: String,
            size: String
        }
    }
</script>

<style lang="less">
    .cl-button {
        padding: 0 40px;
        height: 72px;
        border: var(--border);
        background-color: var(--back-white-color);
        border-radius: 8px;
        line-height: 68px;
        font-size: 28px;
        cursor: pointer;
        text-align: center;
        &:focus {
            outline: none;
        }
        &:active {
            opacity: .5;
        }
        &.disable {
            color: var(--light-font-color);
            cursor: not-allowed;
            &:active {
                opacity: 1;
            }
        }
        &.primary {
            background-color: var(--main-color);
            border-color: var(--main-color);
            color: var(--back-white-color);
        }
        &.error {
            background-color: var(--warn-color);
            border-color: var(--warn-color);
            color: var(--back-white-color);
        }
    }
</style>
